export const cssArr = [
  {
    name: "Css magic",
    link: "https://luayabbas1981.github.io/css-magic/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/css-magic.png",
  },
  {
    name: "Css magicII",
    link: "https://luayabbas1981.github.io/css-magic2/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/css-magic2.png",
  },
  {
    name: "Css magicIII",
    link: "https://luayabbas1981.github.io/css-magicIII/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/css-magic3.png",
  },
  {
    name: "Hummingbird",
    link: "https://luayabbas1981.github.io/hummingbird/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/hummingbird.png",
  },
  {
    name: "Theatre",
    link: "https://luayabbas1981.github.io/theater/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/theatre.png",
  },

  {
    name: "Dance ",
    link: "https://luayabbas1981.github.io/dance/",
    title: "3D",
    type: "3D",
    src: "./cssImages/dance.png",
  },
  {
    name: "Sonic ",
    link: "https://luayabbas1981.github.io/sonic/",
    title: "3D",
    type: "3D",
    src: "./cssImages/sonic.png",
  },
  {
    name: "Pikachu ",
    link: "https://luayabbas1981.github.io/pikachu/",
    title: "2D",
    type: "2D",
    src: "./cssImages/pikachu.png",
  },
  {
    name: "Dragon game",
    link: "https://luayabbas1981.github.io/Dragon/",
    title: "3D animation",
    type: "3D",
    src: "./cssImages/dragon.png",
  },
  {
    name: "Funny square",
    link: "https://luayabbas1981.github.io/funny_square/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/cube.png",
  },
  {
    name: "Logo",
    link: "https://luayabbas1981.github.io/logo/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/logo.png",
  },
  {
    name: "Logo 2 ",
    link: "https://luayabbas1981.github.io/logo-2/",
    title: "2D",
    type: "2D",
    src: "./cssImages/logo3.png",
  },
  {
    name: "Logo 3",
    link: "https://luayabbas1981.github.io/logo-3/",
    title: "2D",
    type: "2D",
    src: "./cssImages/logo2.png",
  },
  {
    name: "Deer",
    link: "https://luayabbas1981.github.io/Deer/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/deer.png",
  },
  {
    name: "Fox",
    link: "https://luayabbas1981.github.io/Fox/",
    title: "2D",
    type: "2D",
    src: "./cssImages/fox.png",
  },
  {
    name: "Atoms",
    link: "https://luayabbas1981.github.io/atoms/",
    title: "3D animation",
    type: "3D",
    src: "./cssImages/atoms.png",
  },
  {
    name: "Antarctic",
    link: "https://luayabbas1981.github.io/antarctic/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/ping.png",
  },
  {
    name: "E under lamp",
    link: "https://luayabbas1981.github.io/Electrons-under-lamp/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/elec.png",
  },
  {
    name: "Bird",
    link: "https://luayabbas1981.github.io/bird/",
    title: "2D clip-path",
    type: "2D",
    src: "./cssImages/bird.png",
  },
  {
    name: "Slack",
    link: "https://luayabbas1981.github.io/Slack/",
    title: "grid",
    src: "./cssImages/slack.png",
  },

  {
    name: "Ubuntu",
    link: "https://luayabbas1981.github.io/ubuntu/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/ubuntu.png",
  },
  {
    name: "Sauer",
    link: "https://luayabbas1981.github.io/Sauer/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/angry.png",
  },
  {
    name: "Wanduhr",
    link: "https://luayabbas1981.github.io/Wanduhr/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/clock.png",
  },
  {
    name: "Ramadan",
    link: "https://luayabbas1981.github.io/Ramadan/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/ramadan.png",
  },
  {
    name: "Golden cube",
    link: "https://luayabbas1981.github.io/Golden-cube/",
    title: "3D animation",
    type: "3D",
    src: "./cssImages/cube3.png",
  },
  {
    name: "React",
    link: "https://luayabbas1981.github.io/React/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/react.png",
  },
  {
    name: "Icons Challenge",
    link: "https://luayabbas1981.github.io/Font-Awesome-Challenge/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/challenge.png",
  },
  {
    name: "Icons war",
    link: "https://luayabbas1981.github.io/Font-Awesome-gangster-war/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/war.png",
  },
  {
    name: "Icons war 2",
    link: "https://luayabbas1981.github.io/Font-Awesome-gangster-war-2/",
    title: "2D animation",
    type: "2D",
    src: "./cssImages/war2.png",
  },
];

export const domArr = [
  {
    name: "Arabic-calligraphy",
    link: "https://luayabbas1981.github.io/arabic-calligraphy/",
    title: "art",
    src: "./domImages/arabic-calligraphy.png",
  },
  {
    name: "English-calligraphy",
    link: "https://luayabbas1981.github.io/english-calligraphy/",
    title: "art",
    src: "./domImages/english-calligraphy.png",
  },
  {
    name: "Arrows",
    link: "https://luayabbas1981.github.io/arrows/",
    title: "javascript game",
    src: "./domImages/arrows.png",
  },
  {
    name: "Unlock",
    link: "https://luayabbas1981.github.io/unlock/",
    title: "javascript game",
    src: "./domImages/unlock.png",
  },
  {
    name: "River-puzzle",
    link: "https://luayabbas1981.github.io/river-puzzle/",
    title: "javascript game",
    src: "./domImages/river-puzzle.png",
  },
  {
    name: "Frogs",
    link: "https://luayabbas1981.github.io/frogs/",
    title: "javascript game",
    src: "./domImages/frogs.png",
  },
  {
    name: "3D-slider",
    link: "https://luayabbas1981.github.io/3D-slider/",
    title: "javascript app",
    src: "./domImages/3D-slider.png",
  },
  {
    name: "Map slider",
    link: "https://luayabbas1981.github.io/map-slider/",
    title: "javascript app",
    src: "./domImages/map-slider.png",
  },
  {
    name: "Clever buyer",
    link: "https://luayabbas1981.github.io/clever-buyer/",
    title: "javascript game",
    src: "./domImages/clever-boy.png",
  },

  {
    name: "Missing part",
    link: "https://luayabbas1981.github.io/missing-part/",
    title: "javascript app",
    src: "./domImages/missing-part.png",
  },
  {
    name: "Pick-up-num",
    link: "https://luayabbas1981.github.io/pick-right-numbers/",
    title: "javascript game",
    src: "./domImages/pick-num.png",
  },
  {
    name: "Rounded name",
    link: "https://luayabbas1981.github.io/rounded-name/",
    title: "javascript app",
    src: "./domImages/rounded name.png",
  },
  {
    name: "C-rose App",
    link: "https://luayabbas1981.github.io/colorful-rose/",
    title: "javascript app",
    src: "./domImages/c-rose.png",
  },
  {
    name: "Focus",
    link: "https://luayabbas1981.github.io/focus/",
    title: "javascript game",
    src: "./domImages/focus.png",
  },
  {
    name: "Focus2",
    link: "https://luayabbas1981.github.io/focus2/",
    title: "javascript game",
    src: "./domImages/focus2.png",
  },
  {
    name: "Focus3",
    link: "https://luayabbas1981.github.io/focus3/",
    title: "javascript game",
    src: "./domImages/focus3.png",
  },
  {
    name: "Focus4",
    link: "https://luayabbas1981.github.io/focus4/",
    title: "javascript game",
    src: "./domImages/focus4.png",
  },
  {
    name: "Focus5",
    link: "https://luayabbas1981.github.io/focus5/",
    title: "javascript game",
    src: "./domImages/focus5.png",
  },

  {
    name: "SSP",
    link: "https://luayabbas1981.github.io/ssp/",
    title: "javascript game",
    src: "./domImages/ssp.png",
  },
  {
    name: "Google dic",
    link: "https://luayabbas1981.github.io/google-dic/",
    title: "javascript - API",
    src: "./domImages/dic.png",
  },
  {
    name: "Memory game",
    link: "https://luayabbas1981.github.io/memory-game/",
    title: "javascript game",
    src: "./domImages/memory.png",
  },
  {
    name: "Falling fruits",
    link: "https://luayabbas1981.github.io/falling-fruits/",
    title: "javascript game",
    src: "./domImages/fruits.png",
  },
  {
    name: "Snake and ladder",
    link: "https://luayabbas1981.github.io/Snake-Ladder/",
    title: "javascript game",
    src: "./domImages/snake.png",
  },
];

export const reactArr = [
  {
    name: "Mack up shop",
    link: "https://luayabbas1981.github.io/react-makeup-shop/",
    title: "React - API",
    src: "./reactImages/make-up.png",
  },
  {
    name: "React calc",
    link: "https://luayabbas1981.github.io/react-calc/",
    title: "React - useReduce",
    src: "./reactImages/calc.png",
  },
  {
    name: "todo app",
    link: "https://luayabbas1981.github.io/react-todo/",
    src: "./reactImages/todo.png",
  },
  {
    name: "My cats",
    link: "https://luayabbas1981.github.io/react-cats/",
    src: "./reactImages/cats.png",
  },
  {
    name: "Software definitions",
    link: "https://github.com/Luayabbas1981/programmierdefinitionen#programmierdefinitionen",
    title: "markdown",
    src: "./reactImages/softwares.png",
  },
];

export const canvasArr = [
  {
    name: "Fisherman",
    link: "https://luayabbas1981.github.io/fishman/",
    title: "canvas-game",
    src: "./canvasImages/fisherman.png",
  },
  {
    name: "Frogs2",
    link: "https://luayabbas1981.github.io/frogs2/",
    title: "canvas-game",
    src: "./canvasImages/frogs2.png",
  },
  {
    name: "Masha&cackes",
    link: "https://luayabbas1981.github.io/masha-and-cakes/",
    title: "canvas-game",
    src: "./canvasImages/masha.png",
  },
  {
    name: "Rainy-image",
    link: "https://luayabbas1981.github.io/rainy-image/",
    title: "canvas",
    src: "./canvasImages/rainy-image.png",
  },
  {
    name: "Chaos",
    link: "https://luayabbas1981.github.io/chaos/",
    title: "canvas",
    src: "./canvasImages/chaos.png",
  },
  {
    name: "Turtle challenge",
    link: "https://luayabbas1981.github.io/race/",
    title: "canvas",
    src: "./canvasImages/turtle.png",
  },
  {
    name: "Stars war",
    link: "https://luayabbas1981.github.io/atari/",
    title: "canvas",
    src: "./canvasImages/atari.png",
  },
  {
    name: "Bouncy ball",
    link: "https://luayabbas1981.github.io/bouncy-ball/",
    title: "canvas-game",
    src: "./canvasImages/colorfulball.png",
  },
  {
    name: "Daring ball",
    link: "https://luayabbas1981.github.io/daring-ball/",
    title: "canvas-game",
    src: "./canvasImages/daring-ball.png",
  },
  {
    name: "U-BOOT",
    link: "https://luayabbas1981.github.io/u-boot/",
    title: "canvas-game",
    src: "./canvasImages/u-boot.png",
  },
];

export const librariesArr = [
  {
    name: "Animate-slider",
    link: "https://luayabbas1981.github.io/virtual-slider/",
    title: "npm-library-demo",
    src: "./librariesImages/animate-slider.png",
  },
  {
    name: "3D-slider",
    link: "https://luayabbas1981.github.io/3d-slider-demo/",
    title: "npm-library-demo",
    src: "./librariesImages/3d-slider.png",
  },
];
